import { CollectionConcatExpression } from "../../../Models/Collections/CollectionConcatExpression";
import { IExpressionEvaluator } from "../../../Models/IExpressionEvaluator";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";

export class CollectionConcatExpressionEvaluator implements IExpressionEvaluator<CollectionConcatExpression> {
  get type(): string {
    return "CollectionConcat";
  }

  private concatValues(values: any[]): any[] {
    const result: any[] = [];
    for (const value of values) {
      if (Array.isArray(value)) {
        result.push(...value);
      } else if (value !== null && value !== undefined) {
        result.push(value);
      }
    }
    return result;
  }

  evaluate(expression: CollectionConcatExpression, context: IExpressionEvaluatorContext): Promise<any> | any {
    const results: any[] = [];
    let hasPromise = false;

    // Evaluate all expressions and check if any are promises
    for (const collectionExpression of expression.Collection) {
      const value = context.Evaluator.evaluate(collectionExpression, context);
      results.push(value);
      if (value instanceof Promise) {
        hasPromise = true;
      }
    }

    // If any promise exists, wait for all and then concat
    if (hasPromise) {
      return Promise.all(results).then((values) => this.concatValues(values));
    }

    // All sync, process immediately
    return this.concatValues(results);
  }
}
